import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import styles from '../styles/frame/frame.module.scss';
import Error from './error';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import { setStatus } from '../../../../../actions/matic-merkle-airdrop-actions';
import Main from './main';
import ShortClaim from './claim/short-claim';
import LongClaim from './claim/long-claim';
import ClaimDetails from './claim/claim-details';
import ClaimConfirm from './claim/claim-confirm';
import ClaimSuccess from './claim/claim-success';
import WithdrawDetails from './withdraw/withdraw-details';
import WithdrawSuccess from './withdraw/withdraw-success';
import WithdrawCountdown from './withdraw/withdraw-countdown';

const renderFrames = (status, withdrowedIndex, setFrameStatus, endDate) => (
  <>
    {status === 2 && <Main setStatus={setFrameStatus} />}
    {status === 3 && <ShortClaim setStatus={setFrameStatus} />}
    {status === 4 && <LongClaim setStatus={setFrameStatus} />}
    {status === 5 && (
      <WithdrawDetails setStatus={setFrameStatus} withdrowedIndex={withdrowedIndex} />
    )}
    {status === 6 && (
      <WithdrawSuccess setStatus={setFrameStatus} withdrowedIndex={withdrowedIndex} />
    )}
    {status === 7 && <ClaimDetails setStatus={setFrameStatus} />}
    {status === 11 && <ClaimConfirm setStatus={setFrameStatus} />}
    {status === 12 && <ClaimConfirm setStatus={setFrameStatus} long />}
    {status === 8 && <ClaimSuccess setStatus={setFrameStatus} />}
    {status === 9 && <ClaimDetails long setStatus={setFrameStatus} />}
    {status === 10 && <WithdrawCountdown setStatus={setFrameStatus} date={endDate} />}
    {status === 99 && <Error setStatus={setFrameStatus} />}
  </>
);

const MerkleAridropFrame = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);
  const address = useSelector((state) => state.account.address);
  const { status, withdrowedIndex } = useSelector((state) => state.merkleAirdrop);
  const isReadyToClaim = useSelector((state) => state.delegator.matic.isReadyToClaim);
  const unclaimedAmount = useSelector((state) => state.delegator.matic.unclaimedAmount);
  const endDate = useSelector((state) => state.delegator.matic.endDate);

  useEffect(() => {
    dispatch(setStatus(2));
  }, [dispatch, isReadyToClaim, unclaimedAmount]);

  const colors = useGetTheme();

  const setFrameStatus = (s, i) => dispatch(setStatus(s, i));

  return (
    <div
      className={cn(styles.cardContainer, { [styles.dark]: dark })}
      style={{ color: colors.text, backgroundColor: colors.stakingFrameBackground }}
    >
      {address && renderFrames(status, withdrowedIndex, setFrameStatus, endDate)}
    </div>
  );
};

export default MerkleAridropFrame;
